// extracted by mini-css-extract-plugin
export default {"dots":"_4yJbS","dot":"RS3-R","selected":"cy5wC","skeleton-progress":"wr97U"};